var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cube-query-renderer"},[_vm._t("default",null,{"loading":_vm.loading,"error":_vm.error,"resultSet":_vm.resultSet,"loadingState":_vm.loadingState})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }